export interface RequestErrorOptions {
  code?: string
  traceId?: string
  requestId?: string
  status?: number
}

export class ApiRequestError extends Error {
  code?: string
  traceId?: string
  requestId?: string
  status?: number

  constructor(message: string, options: RequestErrorOptions = {}) {
    super(message)
    this.name = 'ApiRequestError'
    this.code = options.code
    this.traceId = options.traceId
    this.requestId = options.requestId
    this.status = options.status
  }
}

export function isAuthFailure(error: unknown): boolean {
  if (!(error instanceof ApiRequestError)) return false
  if (error.status === 401 || error.status === 403) return true
  return error.code === 'auth_required' || error.code === 'unauthorized' || error.code === 'forbidden'
}

export function authFailureMessage(error: unknown): string {
  if (!(error instanceof ApiRequestError)) {
    return 'Your session is no longer valid. Please sign in again.'
  }
  if (error.status === 403 || error.code === 'forbidden') {
    return 'You do not have permission to access this resource.'
  }
  return 'Your session has expired or is invalid. Please sign in again.'
}

export function toApiRequestError(
  error: { message: string; code?: string; trace_id: string; request_id?: string; status?: number } | null,
  fallbackMessage: string
): ApiRequestError {
  if (!error) return new ApiRequestError(fallbackMessage)
  return new ApiRequestError(error.message || fallbackMessage, {
    code: error.code,
    traceId: error.trace_id,
    requestId: error.request_id,
    status: error.status,
  })
}

export function shouldRetryRequest(failureCount: number, error: unknown): boolean {
  if (isAuthFailure(error)) return false
  return failureCount < 1
}
